import { ChevronRightIcon } from '@heroicons/react/solid';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useSwiper } from 'swiper/react';

import styles from '../styles/gallery.module.scss';

interface Props {
  imageCount: number|null;
}

function GalleryNavigator({ imageCount }: Props) {
  const swiper = useSwiper();
  const [currentIndex, setCurrentIndex] = useState(0);

  const changePageHandler = (next = false) => {
    if (next) swiper.slideNext();
    else swiper.slidePrev();
    setCurrentIndex(swiper.activeIndex);
  };

  useEffect(() => {
    setCurrentIndex(swiper.activeIndex || 0);
  }, [swiper.activeIndex]);

  useEffect(() => {
    return () => {
      setCurrentIndex(0);
    };
  }, []);

  return (
    <>
      <div
        className={clsx(
          'absolute z-40 translate-x-0 -translate-y-1/2 left-3 right-3 top-1/2',
          styles.navigation
        )}
      >
        <div className="relative w-full h-full">
          {/* next */}
          <span
            className={clsx(
              'w-10 h-10 justify-center items-center opacity-0 flex absolute right-0 -translate-y-1/2 bg-white cursor-pointer rounded-circle hover:ring-2 hover:ring-grey-300',
              {
                'opacity-100': currentIndex !== 0,
              }
            )}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (currentIndex !== 0) {
                changePageHandler();
              }
            }}
          >
            <ChevronRightIcon className="w-6 h-6 text-gray-700" />
          </span>

          {/* prev */}
          <span
            className={clsx(
              'w-10 h-10 flex justify-center items-center opacity-0 absolute left-0 -translate-y-1/2 bg-white cursor-pointer rounded-circle hover:ring-2 hover:ring-grey-300',
              {
                'opacity-100': currentIndex + 1 !== imageCount,
              }
            )}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (currentIndex + 1 !== imageCount) {
                changePageHandler(true);
              }
            }}
          >
            <ChevronRightIcon className="w-6 h-6 text-gray-700 rotate-180" />
          </span>
        </div>
      </div>
    </>
  );
}

export default GalleryNavigator;
